import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#98a9bc", d: "m5.059 4 1.059 1.082-3.224 3.224H18v1.506H2.894l3.224 3.224-1.059 1.083L0 9.059z" }));
const ForwardRef = forwardRef(SvgArrowBack);
export { ForwardRef as ReactComponent };
